import { useAccessTokenForPlanovacQuery } from "@src/__generated__/graphql";
import { Spinner } from "@src/components/ui-kit";
import { planovacUrl } from "@src/config/constants";
import { onError } from "@src/utils/apollo";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { urlJoinP } from "url-join-ts";

interface PlanovacIframeProps {
  iframeKey?: string;
}

enum IframeEvents {
  OpenTaskModal = "openTaskModal",
}

const PlanovacIframe = ({ iframeKey }: PlanovacIframeProps) => {
  const { taskDetailModalStore } = useStore();
  const [iFrameLoading, setIframeLoading] = useState(false);
  const { data, loading } = useAccessTokenForPlanovacQuery({ ...onError() });

  const queryParams = { access_token: data?.getAccessTokenForThirdParty || "" };

  const iframeUrl = urlJoinP(planovacUrl, [], queryParams);

  useEffect(() => {
    window.addEventListener("message", handleIframeEvents);
    return () => window.removeEventListener("message", handleIframeEvents);
  }, []);

  const handleIframeEvents = (
    e: MessageEvent<{ type: IframeEvents; id: string }>,
  ) => {
    let allowedOrigin: string | undefined;
    try {
      allowedOrigin = new URL(planovacUrl).origin;
    } catch {}

    if (!allowedOrigin || allowedOrigin !== e.origin) return;

    if (e.data.type === IframeEvents.OpenTaskModal && e.data.id) {
      taskDetailModalStore.disclosureState.onOpen({
        id: e.data.id,
      });
    }
  };

  if (loading) {
    return <Spinner absolute />;
  }

  return (
    <React.Fragment>
      {iFrameLoading && <Spinner absolute />}
      <iframe
        key={iframeKey}
        src={iframeUrl}
        title="Planovac"
        onLoad={() => setIframeLoading(false)}
        className="h-full w-full"
        frameBorder={0}
      />
    </React.Fragment>
  );
};

export default observer(PlanovacIframe);
